export const exportTableToCsv = (table, fileName = 'cashflow_nominal.csv') => {
  try {
    if (!table) return;
    const visibleColumns = table.getAllLeafColumns().filter((col) => col.getIsVisible());
    const headers = visibleColumns.map((c) => c.columnDef.header);
    const accessors = visibleColumns.map((c) => c.id);

    const rows = table.getPrePaginationRowModel().rows;
    const csvLines = [];
    csvLines.push(headers.join(','));

    rows.forEach((row) => {
      const vals = accessors.map((key) => {
        const v = row.original?.[key];
        const s = v === null || v === undefined ? '' : String(v);
        const escaped = s.replace(/"/g, '""');
        const needsQuotes = /[",\n]/.test(s);
        return needsQuotes ? `"${escaped}"` : escaped;
      });
      csvLines.push(vals.join(','));
    });

    const blob = new Blob([csvLines.join('\n')], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  } catch (e) {
    console.error('CSV export failed', e);
  }
};
